/// <reference path="../react-native-test-flight.d.ts" />

import RNTestFlight from 'react-native-test-flight';
import { Platform } from 'react-native';

export function getRuntimeApiUrlOverride() {
    let isBeta = false;
    if (Platform.OS === 'ios') {
        isBeta = RNTestFlight.isTestFlight;
    }

    return isBeta ? 'https://api.dev.flametask.com' : '';
}

export function useEnviroment() {
    const apiUrlOverride = getRuntimeApiUrlOverride();

    return {
        isBeta: apiUrlOverride !== '',
        apiUrlOverride
    }
}
